import { Formik, Form as FormikForm } from 'formik';
import { useEffect, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { IoIosCamera } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import Input from '../../Components/Input/Input';
import imageAvatar from "../../images/user_avatar.png";
import { editProfileApi, getProfileApi } from '../../Redux/Action/Dashboard';
import { fileBaseUrl } from '../../Utils/Helper';
import Loader from '../../Utils/Loader';
import { errorNotify, successNotify } from '../../Utils/Toast';
import { profileSchema } from '../../Utils/Validations';
import ChangePassword from './ChangePassword';
import './Profile.css';

const Profile = () => {
  const dispatch = useDispatch();

  const { loading, getUserInfo, error } = useSelector((state) => state.getEditProfile);
  const { loading: getLoading, getUserDetails, error: getError } = useSelector((state) => state.getUserProfile);
  // const { loading: departmentLoading, getDepartmentsData } = useSelector((state) => state.departmentsGet)

  const [imagePreview, setImagePreview] = useState(null);
  const [show, setShow] = useState("PROFILE");

  useEffect(() => {
    dispatch(getProfileApi());
    // dispatch(getDepartments())
  }, [])

  useEffect(() => {
    if (getUserInfo?.statusCode === 200) {
      localStorage.setItem("tmsUserDetail", JSON.stringify(getUserInfo.data));
      successNotify("Profile Updated Successfully!");
      dispatch({ type: "EDIT_PROFILE_RESET" })
      dispatch(getProfileApi());
    }
    else if (error) {
      errorNotify(error)
      dispatch({ type: "EDIT_PROFILE_RESET" })
    }
  }, [getUserInfo, error])

  const initialValues = {
    full_name: getUserDetails?.data?.user_name || '',
    email: getUserDetails?.data?.email || '',
    image: getUserDetails?.data?.profile || "",
    department_id: getUserDetails?.data?.department_id || ""
  };

  // const departOptions = getDepartmentsData?.data?.length > 0 ? getDepartmentsData?.data?.map((d) => {
  //   return {
  //     value: d?.id, label: d.name
  //   }
  // }) : []

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append('user_name', values.full_name);
    formData.append('email', values.email);
    formData.append('department_id', getUserDetails?.data?.role === "super-admin" ? 0 : values.department_id);
    values.image && formData.append('image', values.image);

    dispatch(editProfileApi(formData));
  };

  if (getLoading) return <Loader />;

  return (
    <div className='profile_wrapper'>
      <Container fluid>
        <div className='profile_header'>
          <h2>Edit {show === "PROFILE" ? "Profile" : "Password"}</h2>

          {

            show === "PROFILE" ?
              <button
                type='button'
                onClick={() => setShow("PASSWORD")}
                className='login_btn mt-0'
                style={{ width: "fit-content", marginBottom: "12px", padding: "8px 20px" }}
              >
                Edit Password
              </button>
              :
              <button
                type='button'
                onClick={() => setShow("PROFILE")}
                className='login_btn mt-0'
                style={{ width: "fit-content", marginBottom: "12px", padding: "8px 20px" }}
              >
                Edit Profile
              </button>
          }
        </div>

        {
          show === "PROFILE" ?
            <div className='profile_content'>
              <Formik
                initialValues={initialValues}
                validationSchema={profileSchema}
                onSubmit={handleSubmit}
              >
                {({ setFieldValue, errors, touched, values }) => (
                  <FormikForm>
                    <div className='profile_image_upload'>
                      <div className='image_container'>
                        <img
                          src={imagePreview ? imagePreview : getUserDetails?.data?.image ? `${fileBaseUrl}/${getUserDetails?.data?.image}` : imageAvatar}
                          alt="Profile"
                        />

                        <div className='camera_icon'>
                          <IoIosCamera />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  setImagePreview(reader.result);
                                };
                                reader.readAsDataURL(file);
                                setFieldValue('image', file);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <Row className='profile_form'>
                      <Col md={4}>
                        <Input
                          value={values.full_name}
                          type="text"
                          name="full_name"
                          label="Full Name"
                          placeholder="Enter your full name"
                          error={touched.full_name && errors.full_name}
                        />
                      </Col>
                      <Col md={4}>
                        <Input
                          value={values.email}
                          type="text"
                          name="email"
                          label="Email Address"
                          placeholder="Enter your email"
                          isDisable={true}
                          error={touched.email && errors.email}
                        />
                      </Col>
                      {/* {
                        getUserDetails?.data?.role === "super-admin" ? null :
                          <Col md={4}>
                            <Form.Group>
                              <Form.Label>Department </Form.Label>
                              <Select
                                isLoading={departmentLoading}
                                options={departOptions}
                                value={departOptions.find(d => d.value === values.department_id)}
                                onChange={(selected) => setFieldValue('department_id', selected.value)}
                                placeholder="Select Department"
                                styles={dashboardColorStyles}
                              />
                              {touched.department_id && errors.department_id && (
                                <div className="error-message">{errors.department_id}</div>
                              )}
                            </Form.Group>
                          </Col>
                      } */}
                      <Col md={12}>
                        <button
                          type="submit"
                          disabled={loading}
                          className='login_btn mt-0'
                        >
                          {loading ? <Spinner animation='border' size='sm' /> : 'Submit'}
                        </button>
                      </Col>
                    </Row>
                  </FormikForm>
                )}
              </Formik>
            </div> :
            <ChangePassword setShow={setShow} />
        }
      </Container>
    </div>
  );
};

export default Profile;
